import React from 'react'
import {
    InputBase,
    InputLabel,
    FormControl,
    Box,
    useTheme,
    styled,
} from '@mui/material'
import { ReactComponent as ResizeSvg } from './resize.svg'
import { isNilOrEmpty, isWhitespace } from 'packages/core'

const CustomInput = styled(InputBase)(({ theme, paddingLeft }) => ({
    width: '100% !important',
    'label + &': {
        marginTop: theme.spacing(3),
    },
    '& .MuiInputBase-input': {
        borderRadius: '5px',
        position: 'relative',
        backgroundColor: `${theme?.palette?.background?.paper} !important`,
        border: '1px solid #d8d8dd',
        fontSize: '14px',
        padding: '10px 12px',
        paddingLeft: paddingLeft,
        lineHeight: 1.25,
        boxShadow: '0 4px 6px -2px rgba(0, 0, 0, 0.1)',
        '&:hover': {
            borderColor: theme?.palette?.primary?.main,
            backgroundColor: theme?.palette?.background?.paper,
        },
        '&:focus': {
            borderColor: theme?.palette?.primary?.main,
            backgroundColor: theme?.palette?.background?.paper,
        },
        overflowY: 'auto', // for IE
        '&::placeholder': {
            color: '#b4b4b4',
            opacity: 1,
        },
    },
    '&.Mui-focused': {
        backgroundColor: theme?.palette?.common?.white,
    },
    '&.Mui-error': {
        '& .MuiInputBase-input, & textarea': {
            border: '1px solid #f44336 !important',
        },
    },
    '&.MuiInputBase-multiline': {
        padding: 0,
    },
}))

const TextField = ({
    paddingLeft,
    label,
    multiline,
    value,
    maxCharacters,
    required,
    ...rest
}) => {
    const theme = useTheme()

    const error =
        value?.length > maxCharacters ||
        isWhitespace(value) ||
        (required && isNilOrEmpty(value))
    return (
        <>
            <FormControl
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    width: '100%',
                    position: 'relative',
                }}
            >
                {required && (
                    <Box
                        position="absolute"
                        right={6}
                        top={4}
                        color={theme?.palette?.error?.main}
                        zIndex={1}
                        fontSize="17px"
                    >
                        *
                    </Box>
                )}
                {label && (
                    <InputLabel
                        shrink
                        style={{
                            textTransform: 'uppercase',
                            color: '#b4b4b4',
                            paddingLeft: '15px',
                        }}
                    >
                        {label}
                    </InputLabel>
                )}
                <CustomInput
                    multiline={multiline}
                    value={value}
                    error={error}
                    paddingLeft={paddingLeft}
                    {...rest}
                />
                {multiline && (
                    <Box position="absolute" right="4px" bottom="-2px">
                        <ResizeSvg />
                    </Box>
                )}
            </FormControl>
            {maxCharacters && (
                <Box
                    display="flex"
                    justifyContent="flex-end"
                    fontSize="10px"
                    color={error ? '#f44336' : 'inherit'}
                >
                    {value?.length}/{maxCharacters}
                </Box>
            )}
        </>
    )
}

export default TextField
